<template>
    <ul class="bg-white w-40 py-3">
        <div class="absolute -top-1 right-12 rotate-45 w-3 h-3 bg-white"></div>
        <li class="text-left text-base font-semibold px-3 py-[6px] bg-gray-300 hover:text-black hover:bg-gray-300"> Trending </li>
        <li class="text-left text-base font-semibold px-3 py-[6px] text-gray-600 hover:text-black hover:bg-gray-300"> New </li>
    </ul>
</template>

<script>
export default {
    name: 'CategoryList',
}
</script>